import React from 'react';
import IconOne from '../../assets/images/icon/1.png';
import IconTwo from '../../assets/images/icon/2.png';
import IconThree from '../../assets/images/icon/3.png';
import IconFour from '../../assets/images/icon/4.png';

function ServicesHomeOne({ className }) {
    return (
        <section className={`appie-service-area pt-90 pb-100 ${className}`} id="serviceDeals">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="appie-section-title text-center">
                            <h3 className="appie-title">Vendez ou Achetez<br />avec SHOUZ DEALS !
                            </h3>
                            <p>Nous proposons un service avec une nouvelle approche, meilleure que toutes celle du marché actuel.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <div className="icon">
                                <img src={IconOne} className="icon-40" alt="IconOne" />
                                <span>1</span>
                            </div>
                            <h4 className="appie-title">Vendeur</h4>
                            <p>Vendez tout article déplaçable facilement et sans frais. Les vendeurs VIP ont plus de visibilités et fonctionnalités.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-2 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="400ms"
                        >
                            <div className="icon">
                                <img src={IconTwo} className="icon-40" alt="IconTwo" />
                                <span>2</span>
                            </div>
                            <h4 className="appie-title">Acheteur</h4>
                            <p>Discutez directement dans l'application afin de diminuer le prix et avoir plus d'informations sur la qualité de l'article.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-3 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="600ms"
                        >
                            <div className="icon">
                                <img src={IconThree} className="icon-40" alt="IconThree" />
                                <span>3</span>
                            </div>
                            <h4 className="appie-title">Vendeur</h4>
                            <p>Ne vous souciez pas de la livraison nous vous envoyons un livreur pour récupérer votre produit et l'acheminer à l'acheteur.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="appie-single-service text-center mt-30 item-4 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="800ms"
                        >
                            <div className="icon">
                                <img src={IconFour} className="icon-40" alt="IconFour" />
                                <span>4</span>
                            </div>
                            <h4 className="appie-title">Acheteur</h4>
                            <p>Nous vous livrons selon vos désirs/coûts. Nous vous accordons 24h pour signaler si vous êtes satisfait ou vous voulez être remboursé.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesHomeOne;
